import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=6ebff5a9&scoped=true&"
import script from "./Dossier.vue?vue&type=script&lang=js&"
export * from "./Dossier.vue?vue&type=script&lang=js&"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=6ebff5a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebff5a9",
  null
  
)

export default component.exports